import type { SpeechErrorCode } from "./speech.types";

/** Voice input's words. Neutral: nothing here names a field, a tenant or a sample. */
export const VOICE_START_LABEL = "Start voice input";
export const VOICE_STOP_LABEL = "Stop voice input";
export const VOICE_UNSUPPORTED = "Voice input isn't supported in this browser";
export const VOICE_HINT = "Your browser's speech service transcribes what you say.";

export const SPEECH_ERROR_MESSAGES: Record<Exclude<SpeechErrorCode, "aborted">, string> = {
  "not-allowed": "Allow microphone access to use voice input",
  "no-speech": "Didn't catch that. Try again.",
  network: "Voice input couldn't connect",
  unsupported: VOICE_UNSUPPORTED,
  unknown: "Voice input stopped. Try again.",
};

/** Labels of the recording controls in a composer. */
export const VOICE_CONFIRM_LABEL = "Confirm recording";
export const VOICE_CANCEL_LABEL = "Cancel recording";
